import { ActionButton, Icon } from '@fluentui/react';
import DefaultTextView from '../../../common/views/DefaultTextView';
import { Utils } from '../../../common/views/Utils';
import { AddressModel } from '../../models/AddressModel';

export type AddressItemProps = {
    address: AddressModel;
    onEdit: (address: AddressModel) => void;
    onDelete: (address: AddressModel) => void;
}

export default function AddressItemView({ address, onEdit, onDelete }: AddressItemProps) {
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width8 = Utils.getColumnWidth(8);
    const width12 = Utils.getColumnWidth(12);

    const row1 = () => {
        return <div className="ms-Grid-row">
            <div className={width8 + " left"}>{address.address1}</div>
            <div className={width4 + " right"}>{address.isPrimary && <>
                <DefaultTextView text="default" />
            </>}</div>
        </div>
    }

    const row2 = () => {
        return <div className="ms-Grid-row pt-10">
            <div className={width12 + " left"}>{address.address2}</div>
        </div>
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width6 + " left"}>
                <ActionButton
                    iconProps={{ iconName: "Edit" }}
                    onClick={() => onEdit(address)}
                >Edit</ActionButton>
            </div>

            <div className={width6 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "Delete" }}
                    onClick={() => onDelete(address)}
                >Delete</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="pt-5 pb-15 ph-5">
                {row1()}
                {!Utils.isNullOrEmpty(address.address2) && row2()}
            </div>

            {actionRow()}
        </div>
    </div>;
}